import React from 'react';
import styled from 'styled-components';

import { colors } from 'helpers/ColorHelper';

const StyledAvatar = styled.div`
  background-color: ${colors.GRAY};
  background-image: url(${props => props.imgUrl || null});
  background-size: ${props => (props.imgUrl ? '100% 100%' : null)};
  text-align: center;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  height: 3.5rem;
  width: 3.5rem;
  border-radius: 100%;
`;

const StyledAvatarText = styled.div`
  font-weight: 300;
`;

const Avatar = ({ imgUrl, text, ...rest }) => {
  return (
    <StyledAvatar imgUrl={imgUrl} {...rest}>
      {!imgUrl && <StyledAvatarText>{text}</StyledAvatarText>}
    </StyledAvatar>
  );
};

export default Avatar;
